import { IBuyPackageGift } from '../../../../../PayPackageMicrofrontend';
import { IRecommendedPackageGift } from '../../../../types/reducers/recommendedPackages';

export const mapGift = (gift: IRecommendedPackageGift): IBuyPackageGift => {
  const { icon, name, count, durationInDays, price, marketingPrice } = gift;

  return {
    icon,
    name,
    count,
    durationInDays,
    marketingPrice,
    price,
  };
};
